import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-277c3f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xlptdetail-container" }
const _hoisted_2 = { class: "first-tab" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "卸料平台信息", -1))
const _hoisted_4 = { class: "list1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "备案号：", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "安装日期：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "安装单位：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检测单位：", -1))
const _hoisted_10 = { class: "second-tab" }
const _hoisted_11 = { class: "jiance" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实时监测数据", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "载荷(t)", -1))
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "电量(%)", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "设备告警", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多信息", -1))
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备时间：", -1))
const _hoisted_23 = { class: "bottom-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.active) = $event)),
      animated: "",
      swipeable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "设备信息" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: require('./images/xlpt.png')
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.xlptdetail.name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_6,
                      _createElementVNode("span", null, _toDisplayString(_ctx.towerDetail.unloadingInfoDto.projectNo
                      ? _ctx.towerDetail.unloadingInfoDto.projectNo
                      : "暂无信息"), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_7,
                      _createElementVNode("span", null, _toDisplayString(_ctx.towerDetail.unloadingInfoDto.installDate
                      ? _ctx.towerDetail.unloadingInfoDto.installDate
                      : "暂无信息"), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(_ctx.towerDetail.unloadingInfoDto.installCompany
                    ? _ctx.towerDetail.unloadingInfoDto.installCompany
                    : "暂无信息"), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(_ctx.towerDetail.unloadingInfoDto.checkCompany
                      ? _ctx.towerDetail.unloadingInfoDto.checkCompany
                      : "暂无信息"), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "实时监测" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(_ctx.xlptdetail.name), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _hoisted_12,
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.morejianceData && _ctx.morejianceData(...args)))
                  }, [
                    _hoisted_13,
                    _createElementVNode("img", {
                      src: require('./images/more.png')
                    }, null, 8, _hoisted_14)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: require('./images/jiance1.png')
                      }, null, 8, _hoisted_15)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createElementVNode("div", null, _toDisplayString(_ctx.towerDetail.recordTimeDto.loadValue === undefined
                        ? "暂无数据"
                        : _ctx.towerDetail.recordTimeDto.loadValue) + "  /  " + _toDisplayString(_ctx.towerDetail.recordTimeDto.ratedValye == undefined
                        ? 0
                        : _ctx.towerDetail.recordTimeDto.ratedValye), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: require('./images/jiance2.png')
                      }, null, 8, _hoisted_17)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_18,
                      _createElementVNode("div", null, _toDisplayString(_ctx.xlptdetail.battery ? _ctx.xlptdetail.battery : 0) + "  /  100 ", 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moreGaojingData && _ctx.moreGaojingData(...args)))
                }, [
                  _hoisted_20,
                  _createElementVNode("img", {
                    src: require('./images/more.png')
                  }, null, 8, _hoisted_21)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "listdata"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(item.text), 1),
                    _createElementVNode("div", null, [
                      _hoisted_22,
                      _createTextVNode(" " + _toDisplayString(item.deviceTime), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                  yiban: item.level === '1',
                  yanzhong: item.level === '2',
                  jinji: item.level === '3',
                })
                    }, _toDisplayString(item.level === "1"
                    ? "一般"
                    : item.level === "2"
                    ? "严重"
                    : "紧急"), 3)
                  ])
                ], 512)), [
                  [_vShow, _ctx.listData.length !== 0]
                ])
              }), 128)),
              _withDirectives(_createElementVNode("div", _hoisted_23, " 暂无设备告警记录~~ ", 512), [
                [_vShow, _ctx.listData.length === 0]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}